import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const config = {
  apiKey: "AIzaSyBKw_BroYjy-fBk285GH4K7BZRYf1w_3nU",
  authDomain: "auth.goahead.io",
  projectId: "goahead-ae84a",
  storageBucket: "goahead-ae84a.firebasestorage.app",
  messagingSenderId: "317190382549",
  appId: "1:317190382549:web:eb02dbdce23904ec1a135c",
  measurementId: "G-BQ5N1STS1F",
};

const app = initializeApp(config);

const auth = getAuth();
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

export { db, storage, auth, functions };
